/**
 * winデータコンバーター
 * 2022/07/28 各センサーXYZごとに計算していたのを関数化してまとめる(村田)
 * 2023/01/18 配列化し4つ以上のセンサー対応(村田)
 * 注意！）デコードオブジェクトを配列化したため過去のものと互換性がない
 * 2023/09/06 リアルタイム以外も対応。タイムスタンプも付与
 * 2023/11/27 サンプルサイズ0の時最後にポインタを進めていなかったバグ修正
 * 2024/01/15 エンコードを追加
 */
var SHIFT_GAL = 1000000;

/**
 * winデータ⇒加速度配列に直す。タイムスタンプ配列付き
 */
export function decodeWinData(win) {
  var pos = 0;
  var retObj = {x:[],y:[],z:[],tsX:[],tsY:[],tsZ:[]};  // 返り値（winオブジェクト）
  while(win.length > pos) {
    var winlng = parseInt(byte2Hex(win[pos]) + byte2Hex(win[pos+1]) + byte2Hex(win[pos+2]) + byte2Hex(win[pos+3]), 16);
    var winobj = decodeWinBlockData(win.slice(pos, pos+winlng));
    //console.log(winobj.x.length)
    for(var i=0; i < winobj.x.length; i++) {
      if (retObj.x[i] == null) {
        retObj.x[i]=[];retObj.y[i]=[];retObj.z[i]=[];
        retObj.tsX[i]=[];retObj.tsY[i]=[];retObj.tsZ[i]=[];
      }
      retObj.x[i] = retObj.x[i].concat(winobj.x[i]);
      retObj.y[i] = retObj.y[i].concat(winobj.y[i]);
      retObj.z[i] = retObj.z[i].concat(winobj.z[i]);
      //時刻付加
      var timestep = 1000 / winobj.x[i].length;
      for(var t=0; t<winobj.x[i].length; t++){
        retObj.tsX[i].push(winobj.time + timestep * t);
      }
      timestep = 1000 / winobj.y[i].length;
      for(var t=0; t<winobj.y[i].length; t++){
        retObj.tsY[i].push(winobj.time + timestep * t);
      }
      timestep = 1000 / winobj.z[i].length;
      for(var t=0; t<winobj.z[i].length; t++){
        retObj.tsZ[i].push(winobj.time + timestep * t);
      }
    }
    pos += winlng;
    //console.log(" " + pos)
  }
  return retObj;
}

/**
 * winデータ(秒ブロック)⇒加速度配列に直す。タイムスタンプなし※リアルタイム波形想定スピード重視)
 */
export function decodeWinBlockData(win) {
  var winObj = {};  // 返り値（winオブジェクト）
  var obj = { hexIndex: 0 };
  obj.hexIndex += 4;
  var winyy = byte2Hex(win[obj.hexIndex++]);
  var winMM = byte2Hex(win[obj.hexIndex++]);
  var windd = byte2Hex(win[obj.hexIndex++]);
  var winhh = byte2Hex(win[obj.hexIndex++]);
  var winmm = byte2Hex(win[obj.hexIndex++]);
  var winss = byte2Hex(win[obj.hexIndex++]);
  var winlng = parseInt(byte2Hex(win[0]) + byte2Hex(win[1]) + byte2Hex(win[2]) + byte2Hex(win[3]), 16);
  // 頭の時刻
  //ロガーがGMT+9(JST)でタイムゾーンが違う場合
  //winObj.time = new Date(Date.UTC("20"+winyy, winMM-1, windd, winhh, winmm, winss)).getTime() - 1000 * 60 * 60 * 9;
  //ロガーとブラウザのタイムゾーンが同じ場合
  var winDateStr = "20" + winyy + "/" + winMM + "/" + windd + " " + winhh + ":" + winmm + ":" + winss;
  winObj.time = new Date(winDateStr).getTime();
  winObj.x = [];
  winObj.y = [];
  winObj.z = [];
  for (let i=0; winlng > obj.hexIndex; i++) {
    winObj.x[i] = decode(win, obj);
    winObj.y[i] = decode(win, obj);
    winObj.z[i] = decode(win, obj);
  }
  return winObj;
}

function decode(win, obj) {
  obj.hexIndex += 2;
  var hex_str1 = byte2Hex(win[obj.hexIndex++]);
  var hex_str2 = byte2Hex(win[obj.hexIndex++]);
  var smpl_size = parseInt(hex_str1.substr(0, 1), 16);
  var smpl_rate = (parseInt(hex_str1.substr(1, 1), 16) * 256) + (parseInt(hex_str2, 16));
  var sample_init = (win[obj.hexIndex++] & 0xff) << 24 | (win[obj.hexIndex++] & 0xff) << 16 | (win[obj.hexIndex++] & 0xff) << 8 | win[obj.hexIndex++] & 0xff;
  sample_init = sample_init / SHIFT_GAL;
  var data = Array(smpl_rate);
  data[0] = sample_init;
  var hold = sample_init;
  if (smpl_size == 0) {//追加1
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var sht;
      var thex_str1 = byte2Hex(win[obj.hexIndex]);//ab
      if (i % 2 == 0) {//偶数
        sht = (parseInt(thex_str1.substr(0, 1), 16));//a:0-15
      } else {//奇数
        sht = (parseInt(thex_str1.substr(1, 1), 16));//b:0-15
        obj.hexIndex++;
      }
      if (sht > 7) sht = sht - 16; //-8～7
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
    obj.hexIndex++;//最後は98(偶数)なので1つ進める
  } else if (smpl_size == 1) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16));
      if (sht > (Math.pow(2, 7) - 1)) sht = sht - Math.pow(2, 8);
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 2) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 8)) + (parseInt(thex_str2, 16));
      if (sht > (Math.pow(2, 15) - 1)) sht = sht - Math.pow(2, 16);
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 3) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var thex_str3 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 16)) + (parseInt(thex_str2, 16) * Math.pow(2, 8)) + (parseInt(thex_str3, 16));
      if (sht > (Math.pow(2, 23) - 1)) sht = sht - Math.pow(2, 24);
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 4) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var thex_str3 = byte2Hex(win[obj.hexIndex++]);
      var thex_str4 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 24)) + (parseInt(thex_str2, 16) * Math.pow(2, 16)) + (parseInt(thex_str3, 16) * Math.pow(2, 8)) + (parseInt(thex_str4, 16));
      if (sht > (Math.pow(2, 31) - 1)) sht = sht - Math.pow(2, 32);
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 5) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var thex_str3 = byte2Hex(win[obj.hexIndex++]);
      var thex_str4 = byte2Hex(win[obj.hexIndex++]);
      var thex_str5 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 32)) + (parseInt(thex_str2, 16) * Math.pow(2, 24)) + (parseInt(thex_str3, 16) * Math.pow(2, 16)) + (parseInt(thex_str4, 16) * Math.pow(2, 8)) + (parseInt(thex_str5, 16));
      if (sht > (Math.pow(2, 39) - 1)) sht = sht - Math.pow(2, 40);
      var tv = hold + sht / SHIFT_GAL;
      data[i+1] = tv;
      hold = tv;
    }
  }
  return data;
}

//windata={x[0],y[0],z[0],tsx[0],tsy[0],tsz[0],…}
//uint8arrayで返す
export function encodeWinData(windata) {
  if(windata.x.length < 1) return new Uint8Array(0);
  var arr_windata = [];
  for( var i=0; i<windata.x.length; i++) {
    arr_windata.push(windata.x[i]);
    arr_windata.push(windata.y[i]);
    arr_windata.push(windata.z[i]);
  }
  return encodeWin(arr_windata,windata.tsX[0]);
}

//windata=[]
//uint8arrayで返す
export function encodeWin(windata,time_arr) {
  var sfrq = 1000 / (time_arr[1] - time_arr[0]);
  var ret = new Uint8Array(0);
  var windata_1sec = [];
  for( var i=0; i<windata[0].length; i+=sfrq )
  {
    for( var j=0; j<windata.length; j++ )
    {
      windata_1sec[j] = windata[j].slice(i,i+sfrq).map((value)=>{return Math.floor(value * SHIFT_GAL);});
    }
    var date = new Date(time_arr[0]+i/sfrq*1000);
    var YYMMDDhhmmss = date.getFullYear().toString().slice(-2) + ('00' + (date.getMonth()+1)).slice(-2) + ('00' + date.getDate()).slice(-2)
      + ('00' + date.getHours()).slice(-2) + ('00' + date.getMinutes()).slice(-2) + ('00' + date.getSeconds()).slice(-2);
    ret = mergeUint8Array(ret, SetBinData_9CH(windata_1sec,YYMMDDhhmmss,sfrq));
  }
  return ret;
}

//1秒win作成。windataは全チャンネルを配列で渡す。YYMMDDhhmmssは半バイトで1ケタ格納
function SetBinData_9CH(windata,YYMMDDhhmmss,sfrq) {
    var ret = "";
    for(var i=0;i<windata.length;i++){
        var chstr = "";
        var chn0 = 0x00;
        var chn1 = i+1;//ここでは0chは使用しない
        var szsmp0 = 0;
        var szsmp1 = sfrq;
        var d=windata[i][0];//初期値
        chstr += dec2HexString(d,4);//dec2hex
        var flg = 0;
        for (let j = 1; j < sfrq; j++) {
            const dx = windata[i][j] - windata[i][j - 1];
            if (dx >= -8 && dx <= 7) {
                flg = Math.max(flg, 0);
            } else if (dx >= -128 && dx <= 127) {
                flg = Math.max(flg, 1);
            } else if (dx >= -32768 && dx <= 32767) {
                flg = Math.max(flg, 2);
            } else if (dx >= -8388608 && dx <= 8388607) {
                flg = Math.max(flg, 3);
            } else if (dx >= -2147483648 && dx <= 2147483647) {
                flg = Math.max(flg, 4);
            } else if (dx >= -549755813888 && dx <= 549755813887) { // 40ビット対応
                flg = Math.max(flg, 5);
            } else {
                throw new Error("dx out of supported range");
            }
        }
        szsmp0|=(flg<<4);
        chstr = dec2HexString((chn0<<8)+chn1,2) + dec2HexString((szsmp0<<8)+szsmp1,2) + chstr;
        var halfbyte;
        for(var j=1;j<sfrq;j++){
            d=(windata[i][j]-windata[i][j-1]);
            if(flg==0){
                if(j%2==1) {
                  halfbyte=d<<4;
                  if (j == sfrq-1) chstr += dec2HexString(halfbyte,1);//最後
                }
                else chstr += dec2HexString(halfbyte|d&0x0f,1);
            }
            else if (flg == 1 || flg ==2 || flg == 3 || flg == 4 || flg == 5)
            {
              chstr += dec2HexString(d,flg);
            }
        }
        ret += chstr;
    }
    d=ret.length/2+4+6;//チャンネルブロックのバイト数+ブロックサイズ4バイト+日時ヘッダ6バイト
    return hexStringToUint8Array(dec2HexString(d,4)+YYMMDDhhmmss+ret);
}

// utils
function byte2Hex(byte_num) {
  var digits = (byte_num)?.toString(16) || '';//型エラー
  if (byte_num < 16) return '0' + digits;
  return digits;
}

function dec2HexString(d,cnt) {
   const byteLength = cnt * 8;
   const maxVal = Math.pow(2, byteLength);
   if (d < 0) {
       d += maxVal;  // 補数表現に変換
   }
   return ("0".repeat(cnt * 2) + d.toString(16).toUpperCase()).slice(-cnt * 2);
}

function hexStringToUint8Array(hexString){
  var arrayBuffer = new Uint8Array(hexString.length / 2);
  for (var i = 0; i < hexString.length; i += 2) {
    var byteValue = parseInt(hexString.substr(i, 2), 16);
    arrayBuffer[i/2] = byteValue;
  }
  return arrayBuffer;
}

function mergeUint8Array(arr1,arr2) {
  var mergedArr = new Uint8Array(arr1.length + arr2.length);
  mergedArr.set(arr1);
  mergedArr.set(arr2, arr1.length);
  return mergedArr; 
}
